import moment from 'moment';

export default function formatDateWith(
  date: Date | number | string | undefined,
  outFormat?: string,
  inFormat?: string
): string | undefined {
  if (!date) {
    return undefined;
  }

  return moment(date, inFormat).format(outFormat);
}
